
export default {
  computed: {
    checkDegreeCompleted () {
      if(this.savedSchool.bachelors_degree_required === true) {
        for(var d = 0; d < this.allowedUserColleges.length; d++) {
          if((this.allowedUserColleges[d].college_degree_awarded === 'Bachelor'|| this.allowedUserColleges[d].college_degree_awarded === 'Masters' || this.allowedUserColleges[d].college_degree_awarded === 'Doctorate') && this.allowedUserColleges[d].degree === 'Completed') {
            return true
          }
        }
      }
    },

  }
}


// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkdegreemixin.js